import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';
import reportLocales from 'globals/locales/report';
import FsSimpleTable from 'ui-elements/tables/FsSimpleTable';
import {
  getTransactionsData,
  PaginationInfo,
} from 'models/detached-actions/report';
import { FsExpenditureTableTransactionRowDataProps } from 'ui-elements/tables/FsExpenditureTable/FsExpenditureTableTransactionRow/FsExpenditureTableTransactionRow';
import { useReportContext } from 'contexts/report/ReportContext';
import FsCircularProgress from 'ui-elements/loaders/FsCircularProgress';
import FsPagination from 'ui-elements/tabs/FsPagination';
import {
  OverlayBox,
  RelativeBox,
  ScrollBox,
} from './TransactionListContainer.style-elements';
import { getTableProps } from './TransactionListContainer.utils';

const { dialogSubTitle } = reportLocales.recurringTransactionsModal;

const TransactionListContainer: React.FC = () => {
  const {
    report: { userId, activeAccountType },
  } = useReportContext();
  const [isPending, setIsPending] = useState<boolean>(true);
  const [transactions, setTransactions] = useState<
    Array<FsExpenditureTableTransactionRowDataProps>
  >([]);
  const [paginationInfo, setPaginationInfo] = useState<PaginationInfo>();
  const simpleTableProps = getTableProps(transactions);
  const loadTransactions = useCallback(async (): Promise<void> => {
    setIsPending(true);
    const transactionsData = await getTransactionsData({
      userId,
      activeAccountType,
    });
    if (transactionsData?.transactionArray)
      setTransactions(transactionsData.transactionArray);
    if (transactionsData?.paginationInfo)
      setPaginationInfo(transactionsData?.paginationInfo);
    setIsPending(false);
  }, [activeAccountType, userId]);

  const loadTransactionsOnStart = useCallback(async () => {
    await loadTransactions();
  }, [loadTransactions]);

  useEffect(() => {
    loadTransactionsOnStart();
  }, [loadTransactionsOnStart]);

  return (
    <Box>
      <FsSubtitle>{dialogSubTitle}</FsSubtitle>
      <ScrollBox>
        <RelativeBox>
          {isPending && (
            <OverlayBox>
              <FsCircularProgress />
            </OverlayBox>
          )}
          <FsSimpleTable {...simpleTableProps} />
          {paginationInfo && (
            <FsPagination
              data-test="table-pagination"
              onPageChange={loadTransactions}
              paginationInfo={paginationInfo}
              activePageNumber={paginationInfo.currentPage}
            />
          )}
        </RelativeBox>
      </ScrollBox>
    </Box>
  );
};

export default TransactionListContainer;
